import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'
import TableArrowDown from 'component/svgComponents/tableArrowDown'


const Table = ({
  cdMissionList,

  editModal,
  closeModal,
  records,
  handleOrder,
  setCdMissionList,

}) => {
  const [orders,setOrders] = useState([{id: "dsMission", active: true, reverse: true}, {id:"permissionType", active: false, reverse: true}])
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  const changeOrder = (index, previousIndex) => {
    const newOrders = [...orders]
    
    if(newOrders[index].active) {
      newOrders[index].reverse = !newOrders[index].reverse
    }

    else {
      newOrders[index].active = true
      newOrders[previousIndex].active = false
    }

    setOrders(newOrders)
    const active = newOrders.find(or => or.active)
    const direction = active.reverse ? 'ASC' : 'DESC'
    handleOrder(active.id, direction)
  }


  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])
  const renderHeader = () => {

    let checked = false
    let setAll = true
    let checkedClassName = "stock-transfer-checkbox"
    const cdMissionListLength = cdMissionList.length

    if (cdMissionListLength) {
      if (cdMissionListLength < records.length) {
        checked = true
        checkedClassName = "stock-transfer-checked-mid"
      } else {
        checked = true

        setAll = false
      }
    }

    useEffect(() => {

    }, [records])

    return (
      <tr className='pictograms-tr'>
        <th
          onClick={() => {

            setCdMissionList(setAll ? records.map((i) =>  ({id: i.dsMission, permissionType: i.permissionType, })) : [])
          }
            
          }
          className='text-align-center'
        >

          <input checked={checked} type={"checkbox"} className={checkedClassName} />

        </th>
        <th style={{cursor: 'pointer', width: cdMissionList.length < 1 &&  "35%", }} onClick={() => changeOrder(0,1)}>Missão  <TableArrowDown hide={cdMissionList.length > 0} active={orders[0].active} reverse={orders[0].reverse} /></th>
        <th style={{cursor: 'pointer', width: cdMissionList.length < 1 &&  "35%", }} onClick={() => changeOrder(1,0)}>Tipo de permissão <TableArrowDown hide={cdMissionList.length > 0 } active={orders[1].active} reverse={orders[1].reverse}  /></th>

        <th style={{ display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center right-side-icons'>Editar permissão</th>
        <th style={{ display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center right-side-icons'>Excluir permissão</th>
      </tr>
    )
  }

  const renderBody = () => {

    const renderRecord = (record) => {
      
      const { dsMission } = record
   
      const checked = cdMissionList.some((item) => item.id === dsMission)
     
      return (
        <tr className={`${checked ? 'stock-transfer-checked' : ''}`} key={dsMission}>
          <td style={{width: cdMissionList.length < 1 && '25%'}}
            onClick={() =>
              {
            
              setCdMissionList(
                checked
                  ? cdMissionList.filter((i) => i.id !== dsMission)
                  : [...cdMissionList, {id: record.dsMission, permissionType: record.permissionType}]
              )
              }
            }
            className='text-align-center'
          >
            <input type={"checkbox"} className="stock-transfer-checkbox" value={checked} checked={checked} />
          </td>
          <td style={{width: cdMissionList.length < 1 && "35%"}}>{record.dsMission}</td>
          <td style={{width: cdMissionList.length < 1 && "35%"}}>{record.permissionType === "VERIFICACAO" ? "Verificação " : "Aprovação"} </td>
       
          <td style={{display: cdMissionList.length > 0 ? 'none' : ''}} className='mission-block-edit-icon'>
            <Glyph
              type='pencil'
              color='primary'
              onClick={() => editModal(record)}
            />
          </td>

          <td style={{display: cdMissionList.length > 0 ? 'none' : '', paddingRight: "55px"}} className='mission-block-edit-icon'>
            <i  onClick={() => closeModal({id: [record.dsMission]})} className='color-danger glyph glyph-trash-can icon-size pictogram-trash-icon' />
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`mission-block-table-new new pictograms-table ${cdMissionList.length ? 'pictograms-check-mode' : ''}`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  editModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired
}

export default Table
